import { isEmpty } from "../../utils/utils";
import { useBackUrl } from "../../store/hooks";

const Back = ({ renderer = true, message }) => {
  const backUrl = useBackUrl();

  return (
    !isEmpty(backUrl) && (
      <div className="mt-4">
        <a href={backUrl} className="az-link">
          <span>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="20"
              height="20"
              fill="none"
            >
              <path
                fill="#006192"
                fillRule="evenodd"
                d="m7.84537 10.0004 5.24413-5.2442c.3259-.32583.3259-.8525 0-1.17833-.3258-.32583-.8525-.32583-1.1783 0L6.07787 9.4112c-.32583.32584-.32583.8525 0 1.1783l5.83333 5.8334c.1625.1625.3758.2441.5892.2441.2133 0 .4266-.0816.5891-.2441.3259-.3259.3259-.8525 0-1.1784l-5.24413-5.2441Z"
                clipRule="evenodd"
              />
            </svg>
          </span>
          <span className="az-back-label">{message}</span>
        </a>
      </div>
    )
  );
};
export default Back;
